<template>
  <div>
    <el-card shadow="false" style="margin-bottom: 24px">
      <el-descriptions :column="2" labelClassName="descriptions-content">
        <el-descriptions-item label="Event Id">
          {{ basicInfo.id }}
        </el-descriptions-item>
        <el-descriptions-item label="Status">
          {{ basicInfo.statusStr }}
        </el-descriptions-item>
        <el-descriptions-item label="Bureau Name">
          {{ basicInfo.bureauName }}
        </el-descriptions-item>
        <el-descriptions-item label="Completion Date">
          {{ basicInfo.updateTime }}
        </el-descriptions-item>
        <el-descriptions-item label="Product Name">
          {{ basicInfo.productName }}
        </el-descriptions-item>
        <el-descriptions-item label="Submission Date">
          {{ basicInfo.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </el-card>
    <brazil-lookup v-if="$route.query.productName.toString() === '3'" />
    <global-lookup v-if="$route.query.productName.toString() === '1'" />
    <global-report-quick-check
      v-if="$route.query.productName.toString() === '2'"
    />
    <crm-report v-if="$route.query.productName.toString() === '7'" />
    <crm-report v-if="$route.query.productName.toString() === '8'"></crm-report>
    <crm-report v-if="$route.query.productName.toString() === '9'"></crm-report>
    <crm-financial-report v-if="$route.query.productName.toString() === '5'" />
    <ckr-report v-if="$route.query.productName.toString() === '4'" />
  </div>
</template>

<script>
import {
  BrazilLookup,
  GlobalLookup,
  GlobalReportQuickCheck,
  CrmReport,
  CkrReport,
  CrmFinancialReport,
} from './components'

export default {
  data() {
    return {}
  },
  computed: {
    basicInfo() {
      return this.$store.state.bureauReportBasicInfo
    },
  },
  components: {
    CrmFinancialReport,
    CkrReport,
    CrmReport,
    BrazilLookup,
    GlobalLookup,
    GlobalReportQuickCheck,
  },
}
</script>

<style lang="scss" scoped>
:deep(.descriptions-content) {
  color: #000;
  font-size: 14px;
}
</style>
